export class WhyzenForm {
    ssoUrl: string;
    saasId: string;
    idpId: string;
    accountId: string;

    constructor(
        ssoUrl: string,
        saasId: string,
        idpId: string,
        accountId: string
    ) {
        this.ssoUrl = ssoUrl;
        this.saasId = saasId;
        this.idpId = idpId;
        this.accountId = accountId;
    }
}